"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: miimosa/common/v1/collect.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectGoalTypeToJSON = exports.collectGoalTypeFromJSON = exports.CollectGoalType = exports.collectTypeToJSON = exports.collectTypeFromJSON = exports.CollectType = void 0;
/* eslint-disable */
exports.CollectType = {
    COLLECT_TYPE_UNSPECIFIED: "COLLECT_TYPE_UNSPECIFIED",
    /** COLLECT_TYPE_DONATION - Project::Collect::Donation */
    COLLECT_TYPE_DONATION: "COLLECT_TYPE_DONATION",
    /** COLLECT_TYPE_LENDING - Project::Collect::Lending */
    COLLECT_TYPE_LENDING: "COLLECT_TYPE_LENDING",
    /** COLLECT_TYPE_MERCHANT - Project::Collect::Merchant */
    COLLECT_TYPE_MERCHANT: "COLLECT_TYPE_MERCHANT",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function collectTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "COLLECT_TYPE_UNSPECIFIED":
            return exports.CollectType.COLLECT_TYPE_UNSPECIFIED;
        case 1:
        case "COLLECT_TYPE_DONATION":
            return exports.CollectType.COLLECT_TYPE_DONATION;
        case 2:
        case "COLLECT_TYPE_LENDING":
            return exports.CollectType.COLLECT_TYPE_LENDING;
        case 3:
        case "COLLECT_TYPE_MERCHANT":
            return exports.CollectType.COLLECT_TYPE_MERCHANT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.CollectType.UNRECOGNIZED;
    }
}
exports.collectTypeFromJSON = collectTypeFromJSON;
function collectTypeToJSON(object) {
    switch (object) {
        case exports.CollectType.COLLECT_TYPE_UNSPECIFIED:
            return "COLLECT_TYPE_UNSPECIFIED";
        case exports.CollectType.COLLECT_TYPE_DONATION:
            return "COLLECT_TYPE_DONATION";
        case exports.CollectType.COLLECT_TYPE_LENDING:
            return "COLLECT_TYPE_LENDING";
        case exports.CollectType.COLLECT_TYPE_MERCHANT:
            return "COLLECT_TYPE_MERCHANT";
        case exports.CollectType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.collectTypeToJSON = collectTypeToJSON;
exports.CollectGoalType = {
    COLLECT_GOAL_TYPE_UNSPECIFIED: "COLLECT_GOAL_TYPE_UNSPECIFIED",
    COLLECT_GOAL_TYPE_AMOUNT: "COLLECT_GOAL_TYPE_AMOUNT",
    COLLECT_GOAL_TYPE_QUANTITY: "COLLECT_GOAL_TYPE_QUANTITY",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function collectGoalTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "COLLECT_GOAL_TYPE_UNSPECIFIED":
            return exports.CollectGoalType.COLLECT_GOAL_TYPE_UNSPECIFIED;
        case 1:
        case "COLLECT_GOAL_TYPE_AMOUNT":
            return exports.CollectGoalType.COLLECT_GOAL_TYPE_AMOUNT;
        case 2:
        case "COLLECT_GOAL_TYPE_QUANTITY":
            return exports.CollectGoalType.COLLECT_GOAL_TYPE_QUANTITY;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.CollectGoalType.UNRECOGNIZED;
    }
}
exports.collectGoalTypeFromJSON = collectGoalTypeFromJSON;
function collectGoalTypeToJSON(object) {
    switch (object) {
        case exports.CollectGoalType.COLLECT_GOAL_TYPE_UNSPECIFIED:
            return "COLLECT_GOAL_TYPE_UNSPECIFIED";
        case exports.CollectGoalType.COLLECT_GOAL_TYPE_AMOUNT:
            return "COLLECT_GOAL_TYPE_AMOUNT";
        case exports.CollectGoalType.COLLECT_GOAL_TYPE_QUANTITY:
            return "COLLECT_GOAL_TYPE_QUANTITY";
        case exports.CollectGoalType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.collectGoalTypeToJSON = collectGoalTypeToJSON;
//# sourceMappingURL=collect.js.map